import * as React from 'react';

import { compose } from 'recompose';

import Retracked from 'js/app/retracked';
import PendoLib, { LEARNER_API_KEY } from 'js/lib/pendo';
import { useParams } from 'js/lib/useRouter';
import user from 'js/lib/user';

import EnterpriseLearningPathPageRootContent from 'bundles/enterprise-learning-path-description-page/pages/EnterpriseLearningPathPageRootContent';
import EnterpriseLearningPathPageDataProvider from 'bundles/enterprise-learning-path-description-page/providers/pages/EnterpriseLearningPathPageDataProvider';
import EnterprisePageTemplateWrapper from 'bundles/unified-common/pageUtils/EnterprisePageTemplateWrapper';

const EnterpriseLearningPathPageRoot = () => {
  const { programSlug } = useParams();
  React.useEffect(() => {
    try {
      PendoLib.init(
        {
          visitor: {
            id: user.get().external_id,
            isLoggedIn: user.isAuthenticatedUser(),
            isCourserian: user.isCourserian(),
          },
          account: {
            isEnterprise: true,
            // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
            programSlug,
          },
        },
        LEARNER_API_KEY
      );
    } catch {
      // do nothing
    }
  }, [programSlug]);
  return (
    <div data-e2e="enterprise-learning-path-page">
      <EnterpriseLearningPathPageDataProvider>
        <EnterprisePageTemplateWrapper>
          <EnterpriseLearningPathPageRootContent />
        </EnterprisePageTemplateWrapper>
      </EnterpriseLearningPathPageDataProvider>
    </div>
  );
};

export default compose(
  Retracked.createTrackedContainer(() => ({
    namespace: {
      app: 'enterprise_learning_path_description_page',
      page: 'enterprise_learning_path_page',
    },
  }))
)(EnterpriseLearningPathPageRoot);
